enum LOCAL_STORAGE_KEYS {
  TOKEN = 'business-jwt',
  CLEAR = 'wiserrToken',
}

export default LOCAL_STORAGE_KEYS;
